import { api } from 'lib/httpClient';
import downloadFile from 'utils/downloadFile';
import { format } from 'date-fns';

export const exportToCustodian = (
  uploadShareHoldingId,
  notification,
  companyTradingName?: string,
  allocationDate?: Date | string,
) => {
  return async () => {
    try {
      const response = await api.get(
        `allocations/${uploadShareHoldingId}/export-to-custodian`,
        {
          responseType: 'blob',
        },
      );
      if (response.status === 200) {
        const date = allocationDate ? new Date(allocationDate) : new Date();
        const dateStr = format(date, 'dd-MM-yyyy');
        const randomNum = Math.floor(Math.random() * 100000000);
        const randomStr = String(randomNum).padStart(8, '0');
        const tradingName = companyTradingName || '';
        const filename = `Allocation-${tradingName}-${dateStr}-${randomStr}.xlsx`;
        downloadFile(response.data, filename);
        return Promise.resolve(response);
      }
    } catch (error: any) {
      notification.error(error.response.data.responseMsg);
      return false;
    }
  };
};
